import { axiosWithToken } from 'libs/configureAxios'
import { BasicResponse } from 'types/conmon'
import {
  CreatePageViewAuditRequest,
  CreatePageViewAuditResponse,
  ExportPageViewLogsRequest,
  GetAccessLogRequest,
  GetAccessLogResponse,
  GetPageViewLogResponse,
  GetPageViewLogsRequest,
  GetProductLogDetailResponse,
  GetProductLogRequest,
  GetProductLogResponse,
} from './accessLogServices.type'

/**
 * @returns function that handle company services
 */
export class AccessLogServices {
  /**
   * @returns function that handle create page view audit
   */
  async createPageViewAudit(
    body: CreatePageViewAuditRequest,
  ): Promise<BasicResponse<CreatePageViewAuditResponse>> {
    return (await axiosWithToken.post(`/v1/common/audit/page-view`, body)).data
  }

  /**
   * @returns function that handle get page view logs
   */
  async getPageViewLogs(
    params: GetPageViewLogsRequest,
  ): Promise<BasicResponse<GetPageViewLogResponse[]>> {
    return (
      await axiosWithToken.get(`/v1/admin/access_log/page_views`, { params })
    ).data
  }

  /**
   * @returns function that handle export page view logs csv
   */
  async exportPageViewLogsCsv(params: ExportPageViewLogsRequest): Promise<{
    blob: Blob
    contentDisposition?: string
  }> {
    const response = await axiosWithToken.get(
      `/v1/admin/access_log/page_views/export`,
      {
        params,
        responseType: 'blob',
      },
    )

    return {
      blob: response.data,
      contentDisposition: response.headers['content-disposition'],
    }
  }

  /**
   * @returns function that handle get list prompt admin
   */
  async getListAccessLog(
    params: GetAccessLogRequest,
  ): Promise<BasicResponse<GetAccessLogResponse[]>> {
    return (await axiosWithToken.get(`/v1/admin/access_log`, { params })).data
  }

  /**
   * @returns function that handle get list product upload csv log
   */
  async getListProductLog(
    params: GetProductLogRequest,
  ): Promise<BasicResponse<GetProductLogResponse[]>> {
    return (
      await axiosWithToken.get(`/v1/admin/product/import/log`, { params })
    ).data
  }

  /**
   * @returns function that handle get upload csv log product detail
   */
  async getProductLogDetail(id: number): Promise<GetProductLogDetailResponse> {
    return (await axiosWithToken.get(`/v1/admin/product/import/log/${id}`)).data
  }
}
